var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderConfirm h100"},[_c('OrderList',{attrs:{"filters":_vm.filters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }